import { IDocument } from "./types.ts";
import { axiosInstance } from "../axiosConfig.ts";

const basePath = "/v1/documents";

export const documentsAPI = {
  getDocuments: async (): Promise<IDocument[]> => {
    const response = await axiosInstance.get<IDocument[]>(basePath);
    return response.data;
  },
};
